module.exports = __webpack_public_path__ + "img/medidor.eed5e74e.svg";